import { render, staticRenderFns } from "./DataCenter.vue?vue&type=template&id=b1d56ece&scoped=true"
import script from "./DataCenter.vue?vue&type=script&lang=js"
export * from "./DataCenter.vue?vue&type=script&lang=js"
import style0 from "./DataCenter.vue?vue&type=style&index=0&id=b1d56ece&prod&lang=scss&scoped=true"
import style1 from "./DataCenter.vue?vue&type=style&index=1&id=b1d56ece&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d56ece",
  null
  
)

export default component.exports